/* eslint-disable max-lines */
const it = {
  nav: {
    home: "Home",
    drops: "Drops",
    upcomingDrops: "Collezione in vendita",
    cinema: "Cinema",
    archive: "Archivio vendite",
    activeDrops: "Drop Attivi",
    contact: "Contatti",
    signIn: "Accedi",
    apply: "Entra nella Collezione",
    enterVault: "Entra nella Collezione",
    signOut: "Esci",
    hiddenVault: "Una Collezione Nascosta",
    privacy: "Informativa Privacy",
  },
  hero: {
    overline: "Est. 2026 — Un Collezione Nascosta",
    headline1: "Garage Drops.",
    headline2: "Per chi compra storie, non prodotti.",
    subtitle:
      "Un archivio privato di oggetti cinematografici, restomod leggendari e veicoli rari da collezione. Rilasciati senza preavviso. Scomparsi senza spiegazioni.",
    teaserLabel: "Il drop arriva tra",
    liveBadge: "Drop in corso · Solo membri",
    nextDropPrefix: "Prossimo Drop —",
    viewDrops: "Vedi i Drop",
    apply: "Entra nella Collezione",
    scroll: "Scorri",
  },
  countdown: {
    days: "Giorni",
    hours: "Ore",
    minutes: "Minuti",
    seconds: "Secondi",
    live: "Drop attivo",
    closes: "Il drop chiude tra",
    imminent: "Imminente · Annuncio in arrivo",
  },
  manifesto: {
    overline: "Il Manifesto",
    body:
      "Non gestiamo una casa d'aste. Non vendiamo al miglior offerente. Rilasciamo un oggetto raro alla volta, e poi scompare.",
    pillars: [
      {
        n: "01",
        t: "Curato",
        d: "Ogni drop è restaurato, fotografato e documentato in casa.",
      },
      {
        n: "02",
        t: "Numerato",
        d: "Ogni oggetto porta un certificato seriale. Nessuna riproduzione.",
      },
      {
        n: "03",
        t: "Nascosto",
        d: "I dettagli per i membri emergono solo dopo la registrazione.",
      },
    ],
  },
  teaser: {
    overline: "In Arrivo",
    headline: "Qualcosa di raro è in preparazione.",
    body:
      "Il prossimo drop è sigillato dentro la collezione. Candidati come membro per ricevere l'annuncio prima di tutti gli altri.",
    apply: "Candidati per accesso anticipato",
    signIn: "Accedi",
  },
  cinema: {
    overline: "Cinema · Garage Drops",
    headline: "La Collezione, in movimento.",
    body:
      "Frammenti video curati: backstage, restauri, drive cinematici. Selezione che cambia senza preavviso.",
    publicOverline: "Reel pubblico",
    publicTitle: "Frammenti visibili a tutti.",
    exclusiveOverline: "Cinema Esclusivo",
    exclusiveTitle: "Solo per chi è entrato nella collezione.",
    exclusiveLockedHeadline: "C'è un secondo reel, riservato.",
    exclusiveLockedBody:
      "Drive privati, prove tecniche, restomod inediti. Entra nella collezione per accedere a tutto.",
    exit: "Esci",
  },
  contact: {
    overline: "Contatti · Garage Drops",
    headline: "Scrivici. Rispondiamo personalmente.",
    body:
      "Per richieste private, collaborazioni, vendita e consignment. Ogni messaggio finisce in una sola casella — la nostra.",
    directOverline: "Email diretta",
    directHeadline: "Preferisci scrivere direttamente?",
    directBody:
      "Le tue email arrivano nella stessa casella delle conversazioni con i clienti della collezione. Rispondiamo entro 24 ore.",
    firstName: "Nome",
    lastName: "Cognome",
    email: "Email",
    country: "Paese",
    message: "Messaggio",
    messagePlaceholder:
      "Vorrei informazioni · Sono interessato a un drop · Vorrei proporvi un mio veicolo...",
    submit: "Invia messaggio",
    submitting: "Cifratura…",
    successText: "MESSAGGIO RICEVUTO",
    successSub: "Ti risponderemo personalmente.",
    error: "Invio non riuscito. Riprova.",
  },
  releases: {
    overline: "Rilasci attuali",
    headline: "Ora nella Collezione.",
    allDrops: "Tutti i Drop →",
  },
  membership: {
    overline: "Membership",
    headline: "Alcuni drop sono visibili solo quando si apre la porta.",
    body:
      "L'iscrizione è gratuita. Inserisci il paese, scegli una passphrase, e sblocca l'archivio — ogni drop, ogni storia, ogni fotografia.",
    apply: "Entra nella Collezione",
  },
  drops: {
    overline: "La Collezione",
    headline: "Drop attuali.",
    subtitle:
      "Ogni rilascio vive qui solo brevemente. Dopo il countdown, l'oggetto passa a una collezione privata o all'archivio.",
    empty: "Nessun drop visibile ancora. La collezione è tra due rilasci.",
    loading: "Caricamento…",
    membersOnly: "Solo membri",
    live: "Live Ora",
    unlockingOverline: "Stato della Collezione",
    unlockingHeadline: "Il Prossimo Garage Drop si Apre Presto",
    unlockingMystery: "Alcune porte si aprono solo all'ora giusta.",
    showcaseLabel: "Archivio della Collezione — Selezione Anonima",
  },
  drop: {
    backLink: "Torna ai drop",
    lockedOverline: "Drop in arrivo",
    lockedHeadline: "Questo drop sta per essere svelato.",
    lockedBody:
      "I dettagli appariranno qui non appena il countdown raggiunge lo zero. Resta vicino — la collezione si apre presto.",
    backHome: "Torna alla home",
    object: "L'Oggetto",
    specs: "Specifiche",
    gallery: "Galleria",
    story: "La Storia",
    restoration: "Restauro",
    restorationHeadline: "Ricostruito sezione per sezione.",
    beforeAfter: "Trasformazione",
    beforeAfterHeadline: "Prima. Dopo.",
    before: "Prima del restauro",
    after: "Dopo il restauro",
    notFound: "Drop non trovato.",
    backToVault: "Torna alla Collezione",
    teaserOverline: "Drop in arrivo",
    teaserHeadline: "Un solo indizio per ora.",
    teaserBody: "Il drop completo si rivelerà soltanto quando andrà live. Resta nella collezione, ti avviseremo per primi.",
    price: "Prezzo",
    priceOnRequest: "Su richiesta",
    interested: "Sono interessato",
    inCatalogOverline: "In catalogo",
    inCatalogHeadline: "Attualmente non in vendita.",
    inCatalogBody:
      "Solo un pezzo per volta viene rilasciato ufficialmente attraverso il sistema cinematografico dei drop. Questo veicolo vive nell'archivio privato e potrà tornare quando il segnale lo chiamerà.",
    inCatalogMemberBody:
      "Questo veicolo non è attualmente in vendita ma fa parte della collezione privata. Compila il form qui sotto per ricevere informazioni dettagliate.",
    inCatalogCta: "Diventa membro",
    categories: {
      esterno: "Esterno",
      interno: "Interno",
      sx: "Lato sinistro",
      dx: "Lato destro",
      sopra: "Sopra",
      sotto: "Sotto",
      particolari: "Particolari",
      restauro: "Restauro · Foto e Video",
      video: "Video",
    },
  },
  signalPrivileges: {
    overline: "Vantaggi membro",
    headline: "Cosa sblocchi entrando nella Collezione.",
    body: "Diventa membro per accedere all'intero Collezione in vendita e richiedere informazioni private anche sui modelli non ancora in vendita.",
    items: [
      "Accesso al catalogo completo",
      "Storia, foto e dettagli di ogni veicolo — anche non in vendita",
      "Richiesta info privata su qualsiasi modello",
    ],
    footer: "Solo un pezzo per volta entra in vendita. Il resto vive nel catalogo.",
  },
  howItWorks: {
    overline: "Come funziona",
    headline: "Cinque passaggi. Un drop intero.",
    steps: [
      "Un drop viene preparato in privato.",
      "I membri ricevono il segnale per primi.",
      "Il veicolo appare per un tempo limitato.",
      "Le trattative passano dal Concierge.",
      "Il drop entra in archivio e scompare.",
    ],
  },
  experienceTiers: {
    overline: "Livelli di accesso",
    headline: "Tre porte. Tre profondità.",
    body: "Garage Drops non è un marketplace. È una collezione stratificata: la stragrande maggioranza non vedrà mai cosa accade dietro la seconda porta.",
    public: {
      title: "Visitatore",
      access: "Accesso pubblico",
      items: [
        "Manifesto e segnale newsletter",
        "Frammenti cinematografici pubblici",
        "Indizi pre-drop, mai dettagli",
        "Nessun archivio, nessuna galleria",
      ],
      footer: "Una soglia. Niente di più.",
    },
    members: {
      title: "Membro della Collezione",
      access: "Accesso riservato · gratuito",
      items: [
        "Archivio privato dei drop conclusi",
        "Galleria completa, specifiche, storia",
        "Film cinematografici integrali",
        "Notifica drop 24h prima della pubblicazione",
        "Pre-iscrizione ai prossimi drop",
      ],
      footer: "Pochi nomi. Un solo segnale.",
    },
    concierge: {
      title: "Canale Concierge",
      access: "Solo su attivazione",
      items: [
        "Trattative riservate veicolo per veicolo",
        "Veicoli mai indicizzati pubblicamente",
        "Consignment e ricerca su misura",
        "Linea diretta email con l'operatore",
        "Tempistiche, budget, permute negoziati uno a uno",
      ],
      footer: "Apri il Concierge. Lascia un codice.",
    },
  },
  archive: {
    overline: "Confidenziale · Archivio chiuso",
    headline: "Archivio Vendite.",
    body:
      "Veicoli che hanno attraversato la collezione e sono scomparsi. Storie concluse. Trasmissioni terminate.",
    empty:
      "Nessuna trasmissione conclusa per ora. I segnali chiusi appariranno qui.",
    statusLabels: {
      ended: "Segnale terminato",
      closed: "Trasmissione chiusa",
      locked: "Drop locked",
      lost: "Segnale perduto",
      archived: "Archiviato",
    },
    whispers: [
      "Il segnale potrebbe tornare.",
      "Disponibilità sconosciuta.",
      "Trasmissione terminata.",
      "Storia conclusa.",
      "Nessuna conferma di ritorno.",
    ],
  },
  auth: {
    loginOverline: "Accedi",
    loginHeadline: "La collezione ti riconosce.",
    loginBody: "Inserisci i tuoi dati per sbloccare l'archivio.",
    email: "Email",
    passwordLabel: "Passphrase",
    submitLogin: "Accedi",
    submittingLogin: "Verifica…",
    notMember: "Non sei ancora membro?",
    applyLink: "Entra nella Collezione",

    registerOverline: "Candidati",
    registerHeadline: "Entra nell'archivio.",
    registerBody:
      "L'iscrizione è gratuita, e resta tale. Dicci dove ti trovi.",
    country: "Paese",
    firstName: "Nome",
    lastName: "Cognome",
    passwordMin: "Passphrase (min 6)",
    privacyConsent1: "Ho letto e accetto l'",
    privacyConsentLink: "Informativa Privacy",
    privacyConsent2:
      "e acconsento al trattamento dei miei dati ai sensi del GDPR.",
    submitRegister: "Entra nella Collezione",
    submittingRegister: "Apertura…",
    alreadyMember: "Già dentro?",
    signInLink: "Accedi",

    welcomeBack: "Bentornato nella collezione.",
    welcomeNew: "Benvenuto. La collezione è ora aperta.",
    privacyRequired: "Devi accettare l'informativa privacy.",
    cannotSignIn: "Non è stato possibile accedere.",
    cannotRegister: "Non è stato possibile creare l'account.",
  },
  newsletter: {
    overline: "La Newsletter",
    headline: "I drop si annunciano prima di apparire.",
    body:
      "Niente spam, niente rumore di marketplace. Un singolo dispaccio cinematografico quando qualcosa di raro viene rilasciato.",
    yourEmail: "La tua email",
    placeholder: "tu@esempio.com",
    subscribe: "Iscriviti",
    submitting: "...",
    success: "Sei nella lista. Resta vicino alla tua casella.",
    fail: "Iscrizione non riuscita. Riprova.",
  },
  counter: {
    overline: "La Cerchia Interna",
    membersSuffix: "collezionisti hanno le chiavi",
  },
  concierge: {
    label: "Concierge",
    labelMember: "Private Concierge",
    open: "Apri il Concierge",
    close: "Chiudi",
    title: "Concierge",
    titleMember: "Concierge Privato",
    memberBadge: "Membro Collezione",
    memberWelcome:
      "Bentornato/a{name}. Sono il tuo Concierge privato. Conosco ogni drop della collezione — storia, restauro, specifiche. Posso suggerirti veicoli simili, guidarti in un'acquisizione, ricordare le tue conversazioni precedenti. Chiedi pure.",
    back: "Indietro",
    continue: "Continua",
    completeFields: "Completa tutti i campi",
    readyToDispatch: "Pronto al dispatch",
    phaseLabel: {
      activation: "01 / Attivazione",
      qualify: "02 / Pre-qualifica",
      access: "03 / Accesso Collezione",
      dispatch: "04 / Handoff operatore",
      chat: "Linea diretta · Concierge",
      sent: "Trasmissione inviata",
    },
    activationIntro:
      "Seleziona un codice. Nessun saluto, nessuna chiacchiera. Solo trasmissioni.",
    codes: {
      inquiry: "Richiesta informazioni su un veicolo",
      consign: "Propongo un veicolo alla collezione",
      vault: "Accesso alla collezione privata",
      negotiation: "Trattativa riservata in corso",
      qa: "Q&A · Domande aperte sulla Collezione",
      operator: "Linea diretta con l'operatore",
    },
    chat: {
      welcome:
        "Linea aperta. Chiedi quello che vuoi sulla Collezione — drop, membership, archivio, manifesto. Risposte brevi, cinematografiche.",
      intro: "● Q&A · Concierge · Linea aperta",
      introMember: "● Concierge Privato · Linea confidenziale",
      placeholder: "Scrivi la tua domanda…",
      send: "Invia",
      typing: "Sto componendo la risposta…",
      error:
        "La linea è interrotta. Riprova tra un istante o passa a una trasmissione strutturata.",
      escalateLabel: "Vuoi lasciare traccia all'operatore?",
      escalateCta: "Passa a richiesta strutturata",
      escalateLabelMember:
        "Pronto a procedere su un veicolo specifico?",
      escalateCtaMember: "Apri trattativa riservata",
      suggestionsPublic: [
        "Come funziona Garage Drops?",
        "Quanto costa la membership?",
        "Posso proporre un mio veicolo?",
      ],
      suggestionsMember: [
        "Quali drop sono attualmente nella collezione?",
        "Raccontami la storia del Fiat 500 F Restomod",
        "Che veicoli mi consiglieresti se mi piace lo stile vintage italiano?",
        "Come funziona il processo di acquisizione?",
      ],
    },
    fields: {
      name: "Nome e cognome",
      email: "Email di contatto",
      country: "Paese",
      timing: "Tempistica",
      budget: "Budget",
      trade: "Permuta",
      note: "Nota privata",
      notePlaceholder:
        "Veicolo di interesse, marca/modello, dettagli specifici…",
    },
    timing: {
      now: "Immediato",
      q1: "Entro 3 mesi",
      h1: "Entro 6 mesi",
      open: "Tempo aperto",
    },
    budget: {
      b1: "Fino a 50.000 €",
      b2: "50.000 — 150.000 €",
      b3: "150.000 — 350.000 €",
      b4: "350.000 — 750.000 €",
      b5: "Oltre 750.000 €",
    },
    trade: {
      yes: "Sì",
      no: "No",
      maybe: "Valuto",
    },
    access: {
      code: "VAULT",
      headline: "La Collezione è chiusa a questa identità.",
      body: "Per procedere con questo codice devi prima entrare nella collezione. Registrazione gratuita, una sola passphrase.",
      register: "Entra nella Collezione",
      login: "Ho già accesso",
    },
    dispatch: {
      id: "Dispatch ID",
      body: "Trasmissione pronta. L'operatore risponde personalmente, di norma entro 24 ore.",
      bodyMulti: "Trasmissione pronta. Scegli il canale. L'operatore risponde personalmente, di norma entro 24 ore.",
      whatsapp: "Invia via WhatsApp",
      email: "Invia via Email",
      privacy: "Email diretta su casella riservata.",
      privacyMulti: "Cifratura end-to-end via WhatsApp · Email diretta su casella riservata.",
    },
    sent: {
      overline: "Trasmissione inviata",
      headline: "Il segnale è partito.",
      body: "L'operatore riceverà la tua trasmissione. Ti contatterà personalmente, in modo riservato.",
      reset: "Nuova trasmissione",
    },
  },
  intro: {
    line1: "Accesso alla rete privata",
    line2: "Apertura della collezione",
    lineGlitch: "// SEGNALE // SEGNALE //",
    skip: "Salta",
    label: "Garage Drops · Accesso Riservato",
    check1: "Connessione sicura",
    check2: "Identificazione visitatore",
    check3: "Sblocco archivio",
    granted: "ACCESSO AUTORIZZATO",
    welcome: "Benvenuto nella Collezione",
  },
  signal: {
    overline: "Segnale Privato",
    headline: "Una sola trasmissione, quando viene rilasciato qualcosa di raro.",
    body: "Niente rumore di marketplace. Niente spam. I drop si annunciano qui prima di apparire altrove.",
    placeholder: "tua@email.privata",
    submit: "Unisciti al segnale",
    submitting: "Trasmissione…",
    successText: "TRASMISSIONE RICEVUTA",
    successSub: "Resta vicino alla tua casella.",
    error: "Iscrizione non riuscita. Riprova.",
    explainerLabel: "Cosa succede quando ti unisci",
    explainer1: "Solo email — niente account, niente password.",
    explainer2: "Un'unica trasmissione, 24h prima di ogni drop.",
    explainer3: "Zero spam. Cancellazione con un click.",
  },
  offer: {
    overline: "Richiesta privata",
    signedInOverline: "● Stai scrivendo come",
    useOtherEmail: "Usa altra email",
    useMyData: "Usa il mio account",
    headline: "Sei interessato? Lascia traccia.",
    body: "Inserisci i tuoi dati e cosa ti interessa sapere: prezzo, condizioni, disponibilità. Ti contatteremo personalmente, in modo riservato.",
    firstName: "Nome",
    lastName: "Cognome",
    name: "Nome",
    email: "Email",
    country: "Paese",
    phone: "Telefono (opzionale)",
    amount: "Importo offerta",
    message: "Il tuo messaggio",
    messagePlaceholder: "Vorrei conoscere il prezzo · sono interessato a una visita · richiedo informazioni su...",
    submit: "Sono interessato",
    submitting: "Cifratura…",
    privacyNote: "Cifrato · Risposta personale entro 24h",
    successText: "RICHIESTA RICEVUTA",
    successSub: "Un nostro responsabile ti contatterà a breve.",
    error: "Invio non riuscito. Riprova.",
  },
  presentation: {
    featuredOverline: "Drop Attuale",
    liveNow: "Live Ora",
    countdownLabel: "Il drop chiude tra",
    viewFullDrop: "Vedi il drop completo",
    apply: "Entra nella Collezione",
    objectOverline: "L'Oggetto",
    galleryOverline: "Galleria",
    specsOverline: "Specifiche",
    storyOverline: "La Storia",
    closingLine: "Quando il timer finisce, l'oggetto scompare.",
    lockedHeadline: "Questo drop è sigillato.",
    lockedBody:
      "Candidati come membro per sbloccare le fotografie, le specifiche e la storia dietro l'oggetto.",
    archiveLinkOverline: "Archivio",
    archiveLinkBody: "Guarda i drop già passati in collezioni private →",
  },
  footer: {
    description:
      "Un collezione digitale nascosta per drop automobilistici rari e oggetti cinematografici da collezione.",
    navigateOverline: "Naviga",
    legalOverline: "Legale",
    legal: {
      privacy: "Informativa Privacy",
      cookies: "Cookie Policy",
      terms: "Termini di Servizio",
    },
    nav: {
      home: "Home",
      drops: "Drop attuali",
      archive: "Archivio",
      register: "Entra nella Collezione",
      signIn: "Accedi",
    },
    rights: "© {year} Garage Drops",
    tagline: "La Collezione apre al tramonto",
    disclaimer:
      "Oggetto della mia collezione privata personale. Vendita privata. Venduto visto e piaciuto, senza garanzie né diritto di reso.",
  },
  privacy: {
    overline: "Legale",
    title: "Informativa Privacy",
    updated:
      "Ultimo aggiornamento: Febbraio 2026 · Conforme al GDPR UE (Reg. 2016/679) e al D.Lgs. 196/2003.",
    s1Title: "1. Titolare del Trattamento",
    s1Body:
      "Garage Drops (la \"Piattaforma\") è il titolare dei dati personali raccolti tramite questo sito. Per qualsiasi domanda riguardante i tuoi dati, contattaci all'indirizzo",
    s2Title: "2. Dati Raccolti",
    s2Intro: "Trattiamo le seguenti categorie di dati:",
    s2List: [
      "Dati account — indirizzo email, passphrase cifrata, paese.",
      "Iscrizione newsletter — email, paese (facoltativo), timestamp.",
      "Dati tecnici — indirizzo IP, user agent, log di base (max 90 giorni).",
    ],
    s3Title: "3. Base Giuridica e Finalità",
    s3Body:
      "Trattiamo i dati sulle basi giuridiche: (a) necessità contrattuale — per fornire la membership e l'accesso ai drop; (b) consenso — per la newsletter, revocabile in ogni momento; (c) legittimo interesse — per la prevenzione frodi e l'integrità della piattaforma.",
    s4Title: "4. Cookie Policy",
    s4Body:
      "Garage Drops utilizza solo cookie tecnici strettamente necessari (cookie di autenticazione httpOnly). Nessun cookie di tracciamento, advertising o analytics di terze parti.",
    s5Title: "5. Conservazione dei Dati",
    s5Body:
      "I dati account sono conservati per la durata della membership e per 24 mesi dopo la richiesta di cancellazione, per obblighi di registro. I dati newsletter fino alla disiscrizione. I log tecnici per 90 giorni.",
    s6Title: "6. Condivisione dei Dati",
    s6Body:
      "Non vendiamo i tuoi dati. Li condividiamo solo con sub-processori necessari al funzionamento: hosting cloud (UE), invio email (Resend, UE/US con SCC), object storage (infrastruttura Emergent).",
    s7Title: "7. I tuoi diritti (Art. 15-22 GDPR)",
    s7Intro: "Hai il diritto di:",
    s7List: [
      "Accedere ai tuoi dati personali e ottenerne una copia.",
      "Richiedere la rettifica dei dati inesatti.",
      "Richiedere la cancellazione (diritto all'oblio).",
      "Limitare od opporti al trattamento.",
      "Portabilità dei dati.",
      "Revocare il consenso in qualsiasi momento, senza pregiudicare la liceità precedente.",
      "Presentare reclamo al Garante per la Protezione dei Dati Personali.",
    ],
    s7Outro: "Per esercitare uno di questi diritti, scrivi a",
    s8Title: "8. Sicurezza",
    s8Body:
      "Le passphrase sono memorizzate con hash bcrypt. Le comunicazioni avvengono su HTTPS. I token di autenticazione vivono in cookie httpOnly Secure. L'accesso agli strumenti amministrativi è protetto da autenticazione e da una rotta nascosta.",
    s9Title: "9. Termini di Servizio",
    s9Body:
      "Utilizzando la Piattaforma accetti questi termini. La membership è offerta gratuitamente e può essere revocata a nostra discrezione in caso di abuso. Tutti i drop, le fotografie e i contenuti editoriali rimangono di proprietà di Garage Drops o degli artigiani, restauratori e fotografi originali accreditati.",
    s10Title: "10. Modifiche all'Informativa",
    s10Body:
      "Possiamo aggiornare questa Informativa di tanto in tanto. Notificheremo i membri via email di ogni modifica sostanziale.",
  },
  upcoming: {
    overline: "Collezione privata",
    headline: "Collezione in vendita.",
    subtitle:
      "La collezione privata completa. Solo un veicolo per volta entra ufficialmente in vendita; gli altri restano nel catalogo. I membri possono richiedere informazioni su qualsiasi modello.",
    empty: "Il catalogo è in costruzione. Tieni d'occhio questa pagina.",
    locked: "Bloccato",
    filterAll: "Tutto",
    filterAuto: "Auto",
    filterMoto: "Moto",
  },
  quickInquiry: {
    overline: "Richiesta veloce",
    headline: "Una domanda? Scrivici.",
    body: "Senza registrazione. Una breve nota, ti rispondiamo in privato.",
    name: "Nome",
    email: "Email",
    message: "Il tuo messaggio",
    send: "Invia richiesta",
    sent: "Richiesta inviata. Ti rispondiamo a breve.",
    error: "Invio non riuscito. Riprova tra poco.",
    memberHook: "Vuoi vedere il catalogo completo?",
    memberCta: "Diventa membro — accesso totale alla Collezione",
  },
  welcome: {
    overline: "Benvenuto",
    headline: "Cos'è Garage Drops.",
    body1:
      "Garage Drops è una collezione privata di automobili rare e moto rare, restaurate e selezionate, provenienti dalla mia collezione personale e da altre collezioni private accuratamente scelte.",
    body2:
      "Ogni veicolo viene presentato attraverso un rilascio cinematografico dedicato. Un solo veicolo per volta entra ufficialmente in vendita, mentre gli altri rimangono custoditi all'interno della Collezione.",
    body3:
      "Prima della pubblicazione, ogni mezzo viene sottoposto a verifiche e prove su strada. Quando non oggetto di un restauro completo documentato, viene comunque controllato e testato da noi e dalla nostra officina autorizzata, al fine di garantirne il corretto funzionamento e la massima trasparenza verso il futuro proprietario.",
    body4:
      "Vendita privata: ogni veicolo proviene dalla mia collezione personale o da collezioni private selezionate ed è venduto visto e piaciuto, senza garanzia né diritto di reso.",
    languageLabel: "Lingua",
    privacyPrefix: "Continuando dichiari di aver letto la",
    privacyLink: "Privacy Policy",
    continue: "Entra nella Collezione",
  },
};

export default it;
